<script lang="ts" setup>
const appStore = useAppStore();
const imageData = computed(() => {
  return {
    desktop: sessionStorage.getItem('adImagePcUrl') || '',
    mobile: sessionStorage.getItem('adImageSrcPhoneUrl') || ''
  };
});
</script>
<template>
  <div class="marketing-bg">
    <img
      class="bg-desktop"
      v-if="!appStore.isMobile && imageData.desktop"
      :src="imageData.desktop"
      alt=""
    />
    <img
      class="bg-mobile"
      v-if="appStore.isMobile && imageData.mobile"
      :src="imageData.mobile"
      alt=""
    />
  </div>
</template>
<style lang="scss" scoped>
.marketing-bg {
  @include wh;

  // .bg {
  //     &-desktop {
  //         @include wh;
  //         object-fit: cover;
  //     }
  // }

  img {
    @include wh;
    object-fit: cover;
  }
}
</style>
